import React, { Component } from "react";
import { decodeOpAccessToken } from "../../utility";
import { GetGHGEstimationUrl } from "../../config";
import Spinner from "../../UI/Spinner/Spinner";

class DaimlerActualVsExpected extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      organizationId: "",
    };
  }

  componentDidMount() {
    try {
      const jwtToken = localStorage.opsToken;
      const decodedToken = decodeOpAccessToken(jwtToken);
      if (decodedToken) {
        const organizationId =
          decodedToken["https://hasura.io/jwt/claims"]["x-hasura-org-id"];
        this.setState({ organizationId, loader: false });
      } else {
        this.setState({ loader: false });
      }
    } catch (error) {
      console.error("Error decoding ops token:", error);
      this.setState({ loader: false });
    }
  }

  render() {
    const { loader, organizationId } = this.state;

    return (
      <React.Fragment>
        <div className="">
          {loader ? (
            <div
              style={{
                display: "block",
                position: "absolute",
                width: "100%",
                height: "100vh",
                background: "rgba(255,255,255,.8)",
              }}
            >
              <Spinner />
            </div>
          ) : (
            <iframe
              scrolling="yes"
              title="Daimler Actual vs Expected"
              id="iframeDaimlerActualVsExpected"
              src={
                GetGHGEstimationUrl() +
                organizationId +
                "/embed/v1/" +
                localStorage.opsToken +
                "/daimler-actual-vs-expected"
              }
              onLoad={() => this.setState({ loader: false })}
              frameBorder="0"
              width="100%"
              allowFullScreen
              style={{
                height: "calc(100vh - 45px)",
              }}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default DaimlerActualVsExpected;
